import React from 'react';
import Logo from '../svg/logo';
import CustomLink from './link';

const HeaderDE = () => {
	return (
		<header className='navigation-de'>
			<CustomLink classes='logo-container' url='/'>
				<Logo />
			</CustomLink>
		</header>
	);
};
export default HeaderDE;
